import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import ContactUsComp from "../../component/servicescomponent/ContactUsComp";
const ContactUs = () => {
  return (
    <section className="usp_service_section">
      <Navbar />
      <ContactUsComp />
      <Footer />
    </section>
  );
};

export default ContactUs;
